import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { FormFillPayload } from './form-fill-interrupt.schema';

@Component({
  selector: 'tellent-assistant-form-interrupt',
  imports: [ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <form [formGroup]="form()" (ngSubmit)="submit()">
      <h4>{{ payload().schema.name }}</h4>
      @for (f of payload().schema.fields; track f.key) {
        <label>
          <span class="label-text">{{ f.label }}</span>
          @switch (f.type) {
            @case ('textarea') {
              <textarea [formControlName]="f.key" rows="3"></textarea>
            }
            @case ('select') {
              <select [formControlName]="f.key">
                @for (o of f.options ?? []; track o.value) {
                  <option [value]="o.value">{{ o.label }}</option>
                }
              </select>
            }
            @default {
              <input [type]="f.type" [formControlName]="f.key" />
            }
          }
        </label>
      }
      <footer>
        <button type="button" (click)="cancel.emit()">Cancel</button>
        <button type="submit" [disabled]="form().invalid">Submit</button>
      </footer>
    </form>
  `,
  styleUrls: ['./tellent-assistant-form-interrupt.component.less'],
})
export class TellentAssistantFormInterruptComponent {
  public readonly payload = input.required<FormFillPayload>();
  public readonly resolve = output<Record<string, unknown>>();
  public readonly cancel = output<void>();

  protected readonly form = computed<FormGroup>(() => {
    const controls: Record<string, FormControl<unknown>> = {};
    for (const f of this.payload().schema.fields) {
      const initial = this.payload().initial?.[f.key] ?? '';
      controls[f.key] = new FormControl<unknown>(initial, f.required ? Validators.required : []);
    }
    return new FormGroup(controls);
  });

  protected submit(): void {
    const g = this.form();
    if (g.invalid) return;
    this.resolve.emit(<Record<string, unknown>>g.getRawValue());
  }
}
